<template>
    <div>
        <h3>一言</h3>
        <p>
            「一言」は、活動報告や近況、その他の告知事項を掲載できる機能です。
            Xやblueskyのタイムラインと異なり、純粋に作者様の告知事項だけを掲載します。
        </p>
        <h4>使い方</h4>
        <p>
            マイページの一言専用フォームから投稿できます。
        </p>
        <img src="/img/help/other/08.jpg" alt="一言フォーム" class="img-thumbnail mb-3">
        <p>
            一言本文の文字数は250文字です。URLや制御文字も文字数に含まれます。
            250文字以内で本文を入力すれば投稿が可能です。本文未入力状態では投稿できません。
        </p>
        <p>
            また、一言は個々の投稿にレーティングを設定することができます（既定は「なし」になっています）。
            センシティブな内容の投稿にはレーティングを設定してください。
        </p>
        <p>
            本文に１つ以上のURLが含まれる場合、最後のURLからOGP情報が取得できれば、カードを表示します。
        </p>
        <img src="/img/help/other/15.jpg" alt="OGP" class="img-thumbnail mb-3">
        <p>
            一言には画像を１枚だけ添付することができます。
            最大2MBまでの画像を添付することができます。
            画像を添付した場合、本文にURLが含まれていても、カードより画像が優先されます。
            投稿した画像は閲覧者が拡大表示することができます。
        </p>
        <h4>設定と制限</h4>
        <p>
            設定で「一言の最大件数」を設定することができます。
            10件から最大で1,000件です。
            <b>最大件数を超えて投稿した場合、最も古い一言が消滅します。</b>
            10件が制限数の場合、11件目を投稿すると、最初の投稿が消滅します。
            100件を制限数にしていて、途中で10件に制限数を設定変更した場合、
            次の投稿時に最新の10件を残して、古い投稿はすべて一括で消滅します。
        </p>
        <h4>特殊な使い方</h4>
        <p>
            ユーザー登録されていない人からの感想を受け取ったとき、その感想へ返信すると、「一言」へ投稿されます。
            通常、感想は非公開ですが、このケースにおいてのみ、感想とその返信が公開されます。
        </p>
        <h4>返信</h4>
        <p>
            本棚の所有ユーザーだけでなく、本棚を訪れた人が一言へ返信を投稿することができます。
            本棚の所有ユーザー本人以外の返信は、本棚の所有ユーザーが承認するまで表示されません。
        </p>
        <p>
            返信は通常閉じられていて、一言欄の「返信」リンクをクリックすると展開します。
        </p>
        <p>
            返信はそれが属する一言のレーティングに準じます。
            R18の一言にはR18な話題を返信できますが、無制限の一言にセンシティブな内容を投稿しないようにすべきです。
        </p>
        <h5>本棚の所有ユーザーの投稿</h5>
        <p>
            本棚の所有ユーザーはマイページの一言から返信を投稿できます。
            一言に対する補足や追記などをぶら下げることができます。
            本棚の所有ユーザーによる返信は承認の必要なく即座に反映されます。
        </p>
        <p>
            本棚の所有ユーザーは返信に画像を含めることができます。
        </p>
        <h5>訪問ユーザーの投稿</h5>
        <p>
            本棚を訪れたユーザーは一言に返信することができます。
            投稿した返信は、本棚の所有ユーザーが承認するまで表示されません。
        </p>
        <p>
            本棚から投稿する返信には画像を含めることはできません。
        </p>
        <h5>返信の制限</h5>
        <p>
            一つの一言に対して追加できる返信数は {{ $store.state.max_replies }} 件です。
            この件数の返信が投稿されると、それ以上の返信を追加することはできなくなります。
        </p>
        <p>
            一言がローテーションされると、削除された一言への返信も併せて削除されます。
        </p>
    </div>
</template>


<style src="../help.scss" scoped lang="scss"></style>


<script>
export default {
    created() {
        this.useHead({
            title: "一言 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>